import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { CurrencyExchangeSvg } from './svg/currencyExchange';

export const CurrencyExchangeIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={CurrencyExchangeSvg} {...props} />;
